import { Component } from 'preact'
/* eslint-disable import/no-internal-modules */
import Header from '@insided/deprecated-control/header'
import AlertBox, { MessageTypes } from '@insided/deprecated-preact-components/design-system-components/message'
import { CustomPage } from './CustomPagesList'
import GeneralPanel, {
  checkInputValidation,
  ErrorSchemaForTitle,
  FieldsErrorType,
  INVALID_TITLE_GENERIC_MESSAGE
} from './GeneralPanel'
import SEOPanel from './SEOPanel'
import { Permission, Role, RoleList } from './interfaces'
import { mapRolesToPermissions } from './utils'
import axios from 'axios'

interface State extends FieldsErrorType {
  title: string
  slug: string
  seoName: string
  seoDescription: string
  alertMessage: string
  alertMessageType?: null | MessageTypes
  permissions: Permission[]
}

interface Props {
  customPage: CustomPage
  roles: RoleList
  existingRules: Permission[]
}

export class CustomPageEdit extends Component<Props, State> {
  constructor(props: Props) {
    super(props)

    const { title, slug, seo_fields: seoFields } = props.customPage

    this.state = {
      title: title,
      slug: slug,
      seoName: seoFields.name,
      seoDescription: seoFields.description,
      alertMessage: '',
      alertMessageType: null,
      permissions: [],
      fieldsError: {
        title: null
      }
    }

    this.editCustomPage = this.editCustomPage.bind(this)
    this.handleVisibilitySettingsChange = this.handleVisibilitySettingsChange.bind(this)
  }

  async editCustomPage() {
    const { title, slug, seoName, seoDescription, permissions } = this.state
    const titleError = checkInputValidation(ErrorSchemaForTitle, title, INVALID_TITLE_GENERIC_MESSAGE)

    if (titleError) {
      return this.setState({
        fieldsError: {
          title: titleError
        }
      })
    }

    try {
      const { id } = this.props.customPage

      const requestBody = {
        title,
        slug: slug.replace(/^\//g, ''),
        permissions,
        seo_fields: {
          name: seoName,
          description: seoDescription
        }
      }

      const response = await axios.put(`/platform/custom-pages/${id}/edit`, requestBody, {
        validateStatus: (state: number) => {
          return (state >= 200 && state < 300) || state === 422
        }
      })

      if (response.status === 422) {
        this.setState({
          alertMessageType: 'error',
          alertMessage: response.data.error
        })
      } else {
        window.location.assign('/platform/custom-pages?success=true')
      }
    } catch (e) {
      this.setState({
        alertMessageType: 'error',
        alertMessage: 'Something went wrong'
      })
    }
  }

  handleVisibilitySettingsChange(selectedRoles: Role[]) {
    const { mainRoles, customRoles } = this.props.roles
    this.setState({ permissions: mapRolesToPermissions(selectedRoles, [...mainRoles, ...customRoles]) })
  }

  render() {
    const { customPage, roles, existingRules } = this.props
    const { title: pageTitle, slug, seo_fields: seoFields } = customPage
    const { name: seoName, description: seoDescription } = seoFields

    const { alertMessageType, alertMessage, fieldsError } = this.state
    return (
      <div className='custom-pages-edit-page'>
        {alertMessageType && (
          <AlertBox
            isControl
            variant={alertMessageType}
            onDismiss={() => this.setState({ alertMessageType: null })}
            timer={3000}
          >
            {alertMessage}
          </AlertBox>
        )}
        <Header
          title={`Edit page '${pageTitle}'`}
          hasBreadcrumb
          breadcrumbText='Back to Custom Pages Main'
          breadcrumbLink='/platform/custom-pages'
          saveCallback={this.editCustomPage}
          cancelCallback={() => {
            window.location.assign('/platform/custom-pages')
          }}
        />
        <GeneralPanel
          fieldsError={fieldsError}
          title={pageTitle}
          slug={slug}
          roles={roles}
          isSlugReadOnly
          onTitleChange={(value) => this.setState({ title: value })}
          onSlugChange={(value) => this.setState({ slug: value })}
          existingRules={existingRules}
          onVisibilitySettingsChange={this.handleVisibilitySettingsChange}
        />
        <SEOPanel
          name={seoName}
          description={seoDescription}
          onNameChange={(value) => this.setState({ seoName: value })}
          onDescriptionChange={(value) => this.setState({ seoDescription: value })}
        />
      </div>
    )
  }
}

export default CustomPageEdit
